// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 992px){
    .modal-lg, .modal-xl {
        max-width: 1138px;
    }
}

.form-scroll {
    overflow-y: visible;
}

.modal-body {
    overflow: visible;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImVtcGxveWVlLW1vZGFsLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSTtRQUNJLGlCQUFpQjtJQUNyQjtBQUNKOztBQUVBO0lBQ0ksbUJBQW1CO0FBQ3ZCOztBQUVBO0lBQ0ksaUJBQWlCO0FBQ3JCIiwiZmlsZSI6ImVtcGxveWVlLW1vZGFsLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyJAbWVkaWEgKG1pbi13aWR0aDogOTkycHgpe1xuICAgIC5tb2RhbC1sZywgLm1vZGFsLXhsIHtcbiAgICAgICAgbWF4LXdpZHRoOiAxMTM4cHg7XG4gICAgfVxufVxuXG4uZm9ybS1zY3JvbGwge1xuICAgIG92ZXJmbG93LXk6IHZpc2libGU7XG59XG5cbi5tb2RhbC1ib2R5IHtcbiAgICBvdmVyZmxvdzogdmlzaWJsZTtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/employees/employee-modal/employee-modal.component.css"],"names":[],"mappings":"AAAA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;AACA,glBAAglB","sourcesContent":["@media (min-width: 992px){\n    .modal-lg, .modal-xl {\n        max-width: 1138px;\n    }\n}\n\n.form-scroll {\n    overflow-y: visible;\n}\n\n.modal-body {\n    overflow: visible;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
